export default __webpack_public_path__ + "static/media/android.f436fefe.svg";